<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-overlay :show="isLoading" rounded="sm">
          <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-brand href="#" class="text-dark">
                <strong style="color:#3b3e66">Approval Types</strong>
              </b-navbar-brand>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button
                    @click="showAddApproverModal = !showAddApproverModal"
                    class="mr-2"
                    variant="outline-primary"
                    size="sm"
                  >
                    <!-- <font-awesome-icon icon="plus" /> --> 
                    Add Approver
                  </b-button>
                  <b-button variant="outline-info" size="sm" class="mr-2" @click="reloadTable">
                    <!-- <font-awesome-icon icon="sync" /> -->
                    Reload
                  </b-button>
                  <b-form-group>
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>
            <b-table
              sticky-header="calc(100vh - 295px)"
              :busy.sync="isLoading"
              bordered
              ref="table"
              id="my-table"
              :fields="staticFields"
              :items="getApprovalTypesData"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              no-sort-reset
            >
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(is_active)="data">
                <b-badge
                  :variant="data.item.is_active == 1 ? 'success' : 'danger'"
                >{{ data.item.is_active == 1 ? 'Active' : 'In Active'}}</b-badge>
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn
                  @click="editApprovalType(data)"
                  class="mr-2"
                  size="sm"
                  variant="outline-info"
                >
                Edit
                  <!-- <font-awesome-icon icon="edit" /> -->
                </b-btn>
                <b-btn
                  v-if="data.item.is_active == 1"
                  @click="deleteApprovalType(data)"
                  class="mr-2"
                  size="sm"
                  variant="outline-danger"
                >Deactivate</b-btn>
                <b-btn
                  v-if="data.item.is_active == 0"
                  @click="activeApprovalType(data)"
                  class="mr-2"
                  size="sm"
                  variant="outline-success"
                >Activate</b-btn>
              </template>
            </b-table>

            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Showing Result From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :title="isEditApprovalType ? 'Update Approval Type' : 'Add Approval Type'"
      size="md"
      scrollable
      v-model="showAddApproverModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-form-group>
            <label class="text-left">
              Title:
              <span class="required-span">*</span>
            </label>
            <b-form-input
              v-model="$v.form.title.$model"
              :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
              size="sm"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ isEditApprovalType ? 'Your Approval Type is being Updateing......' : 'Your Approval Type is being Creating......' }}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ isEditApprovalType ? 'Your Approval Type has been updated successfully.' : 'Your Approval Type has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" @click="resetModal" variant="outline-danger">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{ isEditApprovalType ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-overlay :show="showDeleteApprovalType" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Deactivating...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetDeleteModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="deleteApprovalTypeCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <b-overlay :show="showActiveApprovalType" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Activating...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetActiveModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="activeApprovalTypeCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "GenralSettingsApproval",
  mixins: [validationMixin],
  data() {
    return {
      showActiveApprovalType: false,
      isEditApprovalType: false,
      showDeleteApprovalType: false,
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      showAddApproverModal: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      toRows: 0,
      fromRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "created_at", label: "Created Date", sortable: true },
        { key: "title", label: "Title", sortable: true },
        { key: "is_active", label: "Is Active", sortable: true },
        { key: "actions", label: "Action", sortable: false },
      ],
      form: {
        title: null,
      },
      approvalTypeId: null,
      processing: false,
      counter: 1,
      interval: null,
    };
  },
  validations: {
    form: {
      title: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    async getApprovalTypesData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let result = HTTP("post", "api/v1/approvals/type/get", formData);

      return result
        .then((response) => {
          const items = response.data.data;
          this.isLoading = false;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
    resetForm() {
      this.form = {
        title: null,
      };
      this.$v.$reset();
    },
    resetModal() {
      this.resetForm();
      this.approvalTypeId = null;
      this.isEditApprovalType = false;
      this.showAddApproverModal = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.isEditApprovalType) {
        this.updateApprovalType().then(this.reloadTable);
      } else {
        this.saveApprovalType().then(this.reloadTable);
      }
    },
    async saveApprovalType() {
      let formData = {
        title: this.form.title,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP("post", "api/v1/approvals/type/create", formData);
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async updateApprovalType() {
      let formData = {
        approval_type_id: this.approvalTypeId,
        title: this.form.title,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP(
          "put",
          "api/v1/approvals/type/" + this.approvalTypeId,
          formData
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    editApprovalType(data) {
      this.isEditApprovalType = true;
      this.approvalTypeId = data.item.id;
      this.form = {
        title: data.item.title,
      };
      this.showAddApproverModal = true;
    },
    deleteApprovalType(data) {
      this.approvalTypeId = data.item.id;
      this.processing = false;
      this.showDeleteApprovalType = true;
    },
    deleteApprovalTypeCall() {
      this.counter = 1;
      this.processing = true;
      this.deleteApprovalTypeApiCall().then(this.resetDeleteModal);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showActiveApprovalType = this.processing = false;
          });
        }
      }, 200);
    },
    async deleteApprovalTypeApiCall() {
      let formData = {
        user_id: localStorage.getItem("userId"),
      };
      try {
        await HTTP(
          "post",
          "api/v1/approvals/type/delete/" + this.approvalTypeId,
          formData
        );
        this.approvalTypeId = null;
      } catch (err) {
        this.approvalTypeId = null;
        return [err];
      }
    },
    resetDeleteModal() {
      this.approvalTypeId = null;
      this.showDeleteApprovalType = false;
      this.reloadTable();
    },
    activeApprovalType(data) {
      this.approvalTypeId = data.item.id;
      this.showActiveApprovalType = true;
    },
    activeApprovalTypeCall() {
      this.counter = 1;
      this.processing = true;
      this.activeApprovalTypeApiCall().then(this.reloadTable);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showActiveApprovalType = this.processing = false;
          });
        }
      }, 200);
    },
    async activeApprovalTypeApiCall() {
      let formData = {
        is_active: 1,
        user_id: localStorage.getItem("userId"),
      };
      try {
        await HTTP(
          "put",
          "api/v1/approvals/type/" + this.approvalTypeId,
          formData
        );
        this.approvalTypeId = null;
      } catch (err) {
        this.approvalTypeId = null;
        return [err];
      }
    },
    resetActiveModal() {
      this.approvalTypeId = null;
      this.showActiveApprovalType = false;
    },
  },
};
</script>
<style scoped>
.card-body {
  padding: 0px;
}
</style>